// clone form data (to avoid direct state mutation - allows updating nested state objects)
const cloneFormData = function () {
    return JSON.parse(JSON.stringify(this.state.formData));
}

export { cloneFormData }